import React, { Component } from 'react';
import SignInPresenter from '@/components/contents/user/SignIn/SignInPresent';
import AuthService from '@/services/auth.service';
import { withRouter } from 'react-router-dom';
import StorageService from '@/services/storage.service';
import { toFormData } from '@/utils/convert.util';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActions } from '@/stores/action/widget.action';
import { getClientMessage, getServerMessage } from '@/utils/massage.util';
import { DO_MAIN } from '@/constants/myconstants';

class SignInContainer extends Component {
    constructor() {
        super();
        this.state = {
            user: { userid: new StorageService().rememberMe.get() || '', password: '', domain: DO_MAIN },
            remember: new StorageService().rememberMe.get() ? true : false,
            signedIn: false,
        };
    }

    handleChangeInput = (e) => {
        const { value, name, type, checked } = e.target,
            sepName = name.split('.');
        const useValue = ['checkbox', 'radio'].includes(type) ? checked : value;
        name.includes('.')
            ? this.setState(
                  {
                      [sepName[0]]: { ...this.state[sepName[0]], [[sepName[1]]]: useValue },
                  } /* , () => { console.log(this.state) } */,
              )
            : this.setState({ [name]: useValue });
    };
    handleRemember() {
        this.state.remember
            ? new StorageService().rememberMe.set(this.state.user.userid)
            : new StorageService().rememberMe.remove();
    }
    handleSubmit = (e) => {
        if (e) e.preventDefault();
        this.handleRemember();
        new AuthService()
            .signIn(toFormData(this.state.user))
            .then((data) => {
                if (data) {
                    Number(data.result) !== 1
                        ? getServerMessage(data.msg).then((msg) => {
                              window.alert(msg);
                          })
                        : this.setState({ signedIn: true }, () => {
                              new StorageService().user_pass.set(this.state.user.password);
                              this.props.history.push('/home');
                              window.location.reload();
                              //   this.props.ModalActions.showStart({status:1});
                          });
                }
            })
            .catch((e) => {
                getClientMessage('error.network.connect').then((msg) => window.alert(msg));
            });
    };

    render() {
        const { user, remember, signedIn } = this.state;
        return (
            <SignInPresenter
                user={user}
                remember={remember}
                signedIn={signedIn}
                onChangeInput={this.handleChangeInput}
                onSubmit={this.handleSubmit}
            />
        );
    }
}

export default connect(null, (dispatch) => ({
    ModalActions: bindActionCreators(modalActions, dispatch),
}))(withRouter(SignInContainer));
